import React, { PureComponent } from "react";
import { store } from "app/store";

const Spin = ({ size, color }) => {
  const colors = store.getState().settings.colors;

  return (
    <div className="deal-spin">
      <i
        className={
          size == "small"
            ? "fa fa-spin fa-spinner"
            : "fa fa-spin fa-spinner fa-3x"
        }
        style={{ color: color || colors.text_color }}
      ></i>
    </div>
  );
};

export { Spin };
